import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useImqBrokerHealthQuestionnaireParams } from 'global/hooks/useImqBrokerHealthQuestionnaireParams';
import ImqBrokerMedicalCategoryPageStore, {
  ImqBrokerMedicalCategoryPageStoreContext,
} from 'store/pages/quote/imq-add-employees/medical-category/pageStore';
import { PageContent } from 'components/quote/imq-add-employees/medical-category';

const ImqBrokerMedicalCategoryPage: React.FC = () => {
  const domainParams = useImqBrokerHealthQuestionnaireParams();
  const { category } = useParams<{ category: string }>();

  if (!category) {
    throw new Error('ImqBrokerMedicalCategoryPage: missing category URL param');
  }

  const decodedCategory = decodeURIComponent(category);

  const pageStore = useMemo(
    () => new ImqBrokerMedicalCategoryPageStore({ ...domainParams, category: decodedCategory }),
    [
      domainParams.groupId,
      domainParams.periodId,
      domainParams.cartId,
      domainParams.subscriberId,
      domainParams.entityId,
      decodedCategory,
    ],
  );

  return (
    <ImqBrokerMedicalCategoryPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </ImqBrokerMedicalCategoryPageStoreContext.Provider>
  );
};

export default ImqBrokerMedicalCategoryPage;
